var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33331V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6666 8L11.3333 4.66667ZM2.66665 3.33333H7.99998V2H2.66665C1.93331 2 1.33331 2.6 1.33331 3.33333V12.6667C1.33331 13.4 1.93331 14 2.66665 14H7.99998V12.6667H2.66665V3.33333Z",
    fill: "#EA5455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2008a75961abd19ca71ef01bf3bfd027.svg";
export { ForwardRef as ReactComponent };